import {EvListReturnType, UseListSort} from './ev-list.models';
import type {AnyFormApi} from '@tanstack/form-core';

interface Props<T> {
  form: AnyFormApi;
  filters: EvListReturnType<T>;
}

export function useListSort<T>(props: Props<T>): UseListSort {
  const toggle: (sort?: string | null) => void = (sort) => {
    const sortSame = props.form.getFieldValue('sort') === sort;
    const orderDesc = sortSame ? (props.form.getFieldValue('order') !== 'desc') : true;
    const newSort: string = sortSame && orderDesc ? null : sort;
    const newOrder: 'desc' | null = !sortSame && orderDesc ? 'desc' : null;
    props.form.setFieldValue('sort', newSort);
    props.form.setFieldValue('order', newOrder);
    props.filters.formChanged({...props.form.state.values, sort: newSort, order: newOrder});
  };

  return {toggle};
}
